//@ts-expect-error
import Cookies from "js-cookie";
import axios from "../api-instance";
import ENDPOINTS from "../consts/endpoints";
import {AuthPayload} from "../common/auth";
import {COOKIE_NAME} from "../consts/user";

export type IAuthRepository = {
    login: (username: string, password: string) => any;
    refreshToken: () => any;
    register: (params: AuthPayload) => any;
    logout: () => any; 
};

const MAX_REFRESH_TOCKEN_RETRY_COUNT = 5;
const COOKIE_EXPIRES = 7; // 7 days

class AuthRepository implements IAuthRepository {
    private api = axios;
    private errorCount = 0;
    constructor() {
        this.api.interceptors.response.use(response => { 
            return response;
        },
        async (error) => {
            const originalRequest = error.config;
            const NETWORK_ERROR = 'ERR_NETWORK';
            const errorCodes = [401];
            if (this.errorCount >= MAX_REFRESH_TOCKEN_RETRY_COUNT) {
                this.logout();
                return Promise.reject(error);
            }
            const isAuthErrorCode = errorCodes.indexOf(error.status ? error.status : error.response.status) !== -1;
            if (isAuthErrorCode || error.code === NETWORK_ERROR && this.errorCount < MAX_REFRESH_TOCKEN_RETRY_COUNT) {
                this.errorCount++; 
                const token = await this.refreshToken();
                if (!token) {
                    return Promise.reject(error);
                }
                //@ts-expect-error fix to string
                this.api.setHeaders(token);
                return this.api(originalRequest);
            } else {
                if (this.errorCount) {
                    this.errorCount = 0;
                }
                return Promise.reject(error);
            }
        });
    }
    login(username: string, password: string) {
        return this.api.post(ENDPOINTS.LOGIN, {username, password})
            .then(({data}) => data?.result).then(result => {
                Cookies.set(COOKIE_NAME, result, {expires: COOKIE_EXPIRES});
                return result;
            });
    }

    refreshToken() {
        this.api.setHeaders()
        return this.api.post(ENDPOINTS.REFRESH_TOKEN).catch(err => console.log(err));
    }

    register({username, email, password}: AuthPayload) {
        return this.api.post(ENDPOINTS.REGISTER, {username, email, password})
            .then(({data}) => data?.result).then(result => {
                Cookies.set(COOKIE_NAME, result, {expires: COOKIE_EXPIRES});
                return result;
            });
    }

    logout() {
        Cookies.remove(COOKIE_NAME);
        //@ts-expect-error
        window.location = '/';
    }

};

export default AuthRepository;